(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-current-competitions.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-current-competitions.js');
"use strict";

const _React = React,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const selectCompetitionsByProductDraw = svs.components.marketplaceCompetition.services.selectors.competitionSelectors.selectCompetitionsByProductDraw;
const useCurrentCompetitions = () => {
  const currentDraw = useCurrentDraw();
  const competitionsByDraw = useSelector(state => selectCompetitionsByProductDraw(state, currentDraw === null || currentDraw === void 0 ? void 0 : currentDraw.productId, currentDraw === null || currentDraw === void 0 ? void 0 : currentDraw.drawNumber));
  return useMemo(() => competitionsByDraw, [competitionsByDraw]);
};
setGlobal('svs.components.tipsen.hooks.useCurrentCompetitions', useCurrentCompetitions);

 })(window);